import React, { useState, useEffect } from 'react'
import { Box, Paper, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { analyticsApi } from '../../../../api/analyticsApi'
import RetentionHeatmap from '../charts/RetentionHeatmap'

const RetentionTab = () => {
  const { t } = useTranslation()
  const theme = useTheme()

  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        const res = await analyticsApi.getRetention('90d')
        setData(res.data)
      } catch (err) {
        console.error('Failed to fetch retention data:', err)
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [])

  const cohorts = data?.cohorts || data || []

  return (
    <Box
      sx={{
        overflow: 'auto',
        '&::-webkit-scrollbar': { display: 'none' },
        scrollbarWidth: 'none',
      }}
    >
      {/* Description */}
      <Typography
        variant="body2"
        sx={{
          color: theme.palette.text.secondary,
          fontSize: '0.84rem',
          mb: 2.5,
          lineHeight: 1.6,
        }}
      >
        {t('analytics_retention_description')}
      </Typography>

      {/* Retention Heatmap */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: '12px',
          border: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
          {t('analytics_weekly_retention')}
        </Typography>
        <RetentionHeatmap data={cohorts} loading={loading} />
      </Paper>
    </Box>
  )
}

export default RetentionTab
